
import { includesValidator } from '../../common/utils/validator';

const ActivatorButtonSize = {
  Large: 'large',
  Small: 'small',
  ExtraSmall: 'x-small',
};

export default {
  props: {
    value: {
      default: () => '',
    },
    range: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: ActivatorButtonSize.Large,
      validator: includesValidator(ActivatorButtonSize),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    date: {
      get() {
        if (this.range && !Array.isArray(this.value)) {
          return this.value ? [this.value] : [];
        }
        if (!this.range && Array.isArray(this.value)) {
          return '';
        }

        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formatedDate() {
      if (Array.isArray(this.value)) {
        return this.value.filter(Boolean).join(' - ');
      }
      if (this.value === '') {
        return this.range ? [] : '';
      }
      return this.value;
    },
    buttonClasses() {
      return [this.size, {
        readonly: this.readonly,
        disabled: this.isDisabled,
      }];
    },
  },
  methods: {
    clearDate(event) {
      event.stopPropagation();
      this.date = this.range ? [] : '';
      this.$emit('clear:date');
    },
  },
};
